import React, { useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Turnstile from "react-turnstile";
import styles from "./contact.module.css"; // Make sure this path is correct

const Contact = () => {
  const form = useRef();
  const [turnstileToken, setTurnstileToken] = useState(null);

  const handleTurnstileVerify = (token) => {
    setTurnstileToken(token);
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    if (!turnstileToken) {
      toast.error("Please complete the CAPTCHA", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const formData = new FormData(form.current);
    const data = {
      from_name: formData.get('from_name'),
      from_email: formData.get('from_email'),
      subject: formData.get('subject'),
      message: formData.get('message'),
      turnstileToken: turnstileToken,
    };

    try {
      const response = await axios.post('https://turnstile.ajesh.workers.dev', data, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data.success) {
        toast.success("Message Sent Successfully!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        document.getElementById("myForm").reset();
        setTurnstileToken(null);
      } else {
        toast.error("Oops! Message Not Sent!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error("Server Error. Please try again.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <div className={styles.formContainer}>
      <form id="myForm" className={styles.form} ref={form} onSubmit={sendEmail}>
        <div className={styles.formGroup}>
          <label htmlFor="from_name" className={styles.label}>YOUR NAME</label>
          <input 
            type="text" 
            name="from_name" 
            id="from_name" 
            className={styles.input} 
            placeholder="John Doe"
            required 
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="from_email" className={styles.label}>YOUR EMAIL</label>
          <input 
            type="email" 
            name="from_email" 
            id="from_email" 
            className={styles.input}
            placeholder="john@example.com"
            required 
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="subject" className={styles.label}>YOUR SUBJECT</label>
          <input 
            type="text" 
            name="subject" 
            id="subject" 
            className={styles.input}
            placeholder="Inquiry"
            required 
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="message" className={styles.label}>YOUR MESSAGE</label>
          <textarea 
            name="message" 
            id="message" 
            className={styles.textarea}
            placeholder="Type your message here..."
            required
          ></textarea>
        </div>
        <div className={styles.formGroup}>
        <div className={styles.turnstileWrapper}>
          <Turnstile
            sitekey="0x4AAAAAAAaiN8RG1qjkSoON"
            onVerify={handleTurnstileVerify}
            theme="dark"
          />
        </div>
      </div>
        <button type="submit" className={styles.formSubmitBtn}>
          <span>Send Message</span>
          <i className="fa fa-send"></i>
        </button>
      </form>
    </div>
  );
};

export default Contact;